"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _setAppdefEnumFilterSettings = _interopRequireDefault(require("../../helpers/setAppdefEnumFilterSettings.js"));
var _queryVariablesHelper = _interopRequireDefault(require("../../helpers/queryVariablesHelper.js"));
var _cccisdTabletop = _interopRequireDefault(require("cccisd-tabletop"));
var _cccisdTableRenders = _interopRequireDefault(require("cccisd-table-renders"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));
var _Buttons = _interopRequireDefault(require("../Buttons"));
var _classnames4 = _interopRequireDefault(require("classnames"));
var _cccisdStyleBible = _interopRequireDefault(require("cccisd-style-bible"));
var _cccisdTabs = _interopRequireDefault(require("cccisd-tabs"));
var _dashboard = _interopRequireDefault(require("./dashboard.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var rendersContext = require.context('resources/assets/js', true, /^\.\/renders\/([^/]+\/){1}index\.js$/);
var buttonsContext = require.context('resources/assets/js', true, /^\.\/vendor\/app-definitions\/tableButtons\/([^/]+\/){1}index\.js$/);
var Dashboard = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(Dashboard, _React$Component);
  function Dashboard() {
    var _this;
    _classCallCheck(this, Dashboard);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Dashboard, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getRenderFromContext", function (context, type) {
      if (!context) {
        return function () {};
      }
      var foundKey = (0, _find2["default"])(context.keys(), function (key) {
        var renderType = key.replace(/^.*\/[^/]+\/([^/]+)\/index\.js$/, '$1');
        return type === renderType;
      });
      if (foundKey) {
        return context(foundKey);
      }
      console.warn("App renderer not found for \"".concat(type, "\" in app"));
      return undefined;
    });
    _defineProperty(_assertThisInitialized(_this), "getButtonsFromContext", function (context, handle) {
      if (!context) {
        return function () {};
      }
      var foundKey = (0, _find2["default"])(context.keys(), function (key) {
        var buttonHandle = key.replace(/^.*\/[^/]+\/([^/]+)\/index\.js$/, '$1');
        return handle === buttonHandle;
      });
      if (foundKey) {
        return context(foundKey);
      }
      console.warn("App table button not found for \"".concat(handle, "\" in app"));
      return undefined;
    });
    _defineProperty(_assertThisInitialized(_this), "processTable", function (view) {
      var cols = [];
      view.table.columns.forEach(function (c) {
        var column = {};
        if ('renderAs' in c) {
          var tmpRender;
          var renderClass = function renderClass() {};
          if (c.renderAs["class"] === 'app') {
            tmpRender = _this.getRenderFromContext(rendersContext, c.renderAs.type);
            if (!(0, _isUndefined2["default"])(tmpRender)) {
              renderClass = tmpRender["default"];
            }
          } else {
            renderClass = _cccisdTableRenders["default"][c.renderAs["class"]][c.renderAs.type];
          }
          column.render = renderClass(c.renderAs.settings);
          column = Object.assign(column, (0, _setAppdefEnumFilterSettings["default"])(c, column));
        }
        cols.push(Object.assign(c, column));
      });
      var variables = {};
      if ('requiredVariables' in view.table) {
        variables = (0, _queryVariablesHelper["default"])(view.table.requiredVariables);
      }
      return Object.assign((0, _omit2["default"])(view.table, ['columns', 'requiredVariables']), {
        columns: cols,
        graphqlVariables: variables
      });
    });
    _defineProperty(_assertThisInitialized(_this), "processBottomTable", function (view) {
      var bottomCols = [];
      view.bottomTable.columns.forEach(function (bc) {
        var bcolumn = {};
        if ('renderAs' in bc) {
          var tmpRender;
          var renderClass = function renderClass() {};
          if (bc.renderAs["class"] === 'app') {
            tmpRender = _this.getRenderFromContext(rendersContext, bc.renderAs.type);
            if (!(0, _isUndefined2["default"])(tmpRender)) {
              renderClass = tmpRender["default"];
            }
          } else {
            renderClass = _cccisdTableRenders["default"][bc.renderAs["class"]][bc.renderAs.type];
          }
          bcolumn.render = renderClass(bc.renderAs.settings);
          bcolumn = Object.assign(bcolumn, (0, _setAppdefEnumFilterSettings["default"])(bc, bcolumn));
        }
        bottomCols.push(Object.assign(bc, bcolumn));
      });
      var variables = {};
      if ('requiredVariables' in view.bottomTable) {
        variables = (0, _queryVariablesHelper["default"])(view.bottomTable.requiredVariables);
      }
      return Object.assign((0, _omit2["default"])(view.bottomTable, ['columns']), {
        columns: bottomCols,
        graphqlVariables: variables
      });
    });
    _defineProperty(_assertThisInitialized(_this), "processProps", function (tableTop) {
      // const { tableTop } = this.props;
      var tableTopProps = tableTop;
      var views = [];
      tableTopProps.views.forEach(function (view) {
        var newView = (0, _omit2["default"])(view, ['table', 'bottomTable']);

        // columns
        var table = _this.processTable(view);
        if ('bottomTable' in view) {
          var bottomTable = _this.processBottomTable(view);
          newView.bottomTable = Object.assign((0, _omit2["default"])(view.bottomTable, ['columns']), bottomTable);
        }

        // buttons
        var buttons = [];
        if ('buttons' in view) {
          view.buttons.forEach(function (b) {
            var Button;
            if ('componentHandle' in b) {
              var tmpButton = _this.getButtonsFromContext(buttonsContext, b.componentHandle);
              if (!(0, _isUndefined2["default"])(tmpButton)) {
                Button = tmpButton["default"];
              }
            } else {
              Button = _Buttons["default"][b.name];
            }
            buttons.push(function (_ref) {
              var loadData = _ref.loadData,
                visualize = _ref.visualize;
              return /*#__PURE__*/_react["default"].createElement(Button, {
                settings: b.settings,
                loadData: loadData,
                visualize: visualize
              });
            });
          });
        }
        newView.buttons = buttons;
        newView.table = Object.assign((0, _omit2["default"])(view.table, ['columns']), table);
        views.push(newView);
      });
      return {
        views: views,
        handle: tableTopProps.handle,
        saveState: tableTopProps.saveState
      };
    });
    return _this;
  }
  _createClass(Dashboard, [{
    key: "render",
    value: function render() {
      if ((0, _isEmpty2["default"])(this.props.tabs)) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "appdefs-dashboard"
        }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h1", null, this.props.pageTitle), /*#__PURE__*/_react["default"].createElement("p", null, this.props.pageDescription)), /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames4["default"])(_defineProperty({}, "".concat(_cccisdStyleBible["default"][this.props["class"]]), true))
        }, /*#__PURE__*/_react["default"].createElement(_cccisdTabletop["default"], this.processProps(this.props.tableTop))));
      }
      if (this.props.tabs.length === 1) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "appdefs-dashboard"
        }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h1", null, this.props.pageTitle), /*#__PURE__*/_react["default"].createElement("p", null, this.props.pageDescription)), /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames4["default"])(_defineProperty({}, "".concat(_cccisdStyleBible["default"][this.props["class"]]), true))
        }, /*#__PURE__*/_react["default"].createElement(_cccisdTabletop["default"], this.processProps(this.props.tabs[0].tableTop))));
      }
      var tabList = [];
      for (var i = 0; i < this.props.tabs.length; i++) {
        var t = this.props.tabs[i];
        var content = null;
        if (t.componentHandle) {
          var CustomComponent = this.getRenderFromContext(rendersContext, t.componentHandle);
          if (CustomComponent) {
            CustomComponent = CustomComponent["default"];
            var customComponentProps = t.componentProps || {};
            content = /*#__PURE__*/_react["default"].createElement("div", {
              className: _dashboard["default"].margin
            }, /*#__PURE__*/_react["default"].createElement(CustomComponent, customComponentProps));
          } else {
            console.warn("No component ".concat(t.componentHandle, " exists"));
          }
        } else {
          content = /*#__PURE__*/_react["default"].createElement("div", {
            className: _dashboard["default"].margin
          }, /*#__PURE__*/_react["default"].createElement(_cccisdTabletop["default"], this.processProps(t.tableTop)));
        }
        tabList.push({
          name: t.handle,
          title: t.label,
          content: content
        });
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "appdefs-dashboard"
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h1", null, this.props.pageTitle), /*#__PURE__*/_react["default"].createElement("p", null, this.props.pageDescription)), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '1em',
          padding: '1em'
        },
        className: (0, _classnames4["default"])(_defineProperty(_defineProperty({}, "".concat(_cccisdStyleBible["default"][this.props["class"]]), true), "".concat(_dashboard["default"].margin), true))
      }, /*#__PURE__*/_react["default"].createElement(_cccisdTabs["default"], {
        tabList: tabList
      })));
    }
  }]);
  return Dashboard;
}(_react["default"].Component);
_defineProperty(Dashboard, "propTypes", {
  tableTop: _propTypes["default"].object,
  pageTitle: _propTypes["default"].string,
  pageDescription: _propTypes["default"].string,
  tabs: _propTypes["default"].array,
  "class": _propTypes["default"].string
});
_defineProperty(Dashboard, "defaultProps", {
  pageTitle: 'Dashboard',
  pageDescription: '',
  "class": '',
  tabs: []
});